function decimalToHex(opacity: number): string {
  if (opacity < 0 || opacity > 1) {
    throw new Error('Opacity must be between 0 and 1');
  }
  const hex = Math.round(opacity * 255).toString(16);
  return hex.padStart(2, '0').toUpperCase();
}

export { decimalToHex };
